import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createProvider } from "../api/createProvider";
import type { ProviderData } from "../types";

export const useCreateProvider = (): UseMutationResult<ApiResponse, ApiError, ProviderData> => {
    return useMutation({
        mutationFn: createProvider,
    })
}
